import { LOCALE_UA } from "./locale-ua";
import { LOCALE_EN } from "./locale-en";

export const GET_PRIME_LOCALE: Record<string, Record<string, unknown>> = {
  ["ua-UK"]: LOCALE_UA,
  ["en-US"]: LOCALE_EN,
};
